import { Base2Presenter } from "core/presenter";
import * as Repositories from "core/repository";

export default class LayoutPresenter extends Base2Presenter {
  static sStatesWithoutLoader = [
    "app.login",
    "app.signup",
    "app.password-recovery"
  ];

  initialState() {
    return {
      showLoader: true
    };
  }

  async onStart() {
    const repositoryPromises = Object.values(Repositories)
      .filter(repository => repository.prepare)
      .map(repository => repository.prepare());

    await Promise.all([...repositoryPromises]);

    this.router.transitionService.onSuccess({}, transition => {
      if (LayoutPresenter.sStatesWithoutLoader.includes(transition.to().name)) {
        this.enqueue({ showLoader: false });
      }
    });

    if (LayoutPresenter.sStatesWithoutLoader.includes(this.route.name)) {
      this.enqueue({ showLoader: false });
    } else {
      const loggedInUser = await Repositories.UserRepository.getLoggedInUser();

      if (loggedInUser.success) {
        this.enqueue({ showLoader: false });
      } else {
        this.navigateTo("app.login");
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/support/layout/presenter.js